import moment from "moment";
import { useEffect, useState } from "react";
import { FaCaretDown, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { Button, Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { DiscountIcon } from "../../assets/designedPickedIcons";
import { discountCategories2, dummyDays } from "../../dummyData";
import { useTranslation } from "../../languages";
import DatePickInput from "../inputs/DatePickInput";
import LabeledCheckedInput from "../inputs/LabeledCheckedInput";
import LabeledCheckedInput2 from "../inputs/LabeledCheckedInput2";
import NormalInput2 from "../inputs/NormalInput2";
import { MdEdit } from "react-icons/md";

const DiscountModal = ({ label, value = [], setValue }) => {
  const { t } = useTranslation();
  const [indexToEdit, setIndexToEdit] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [discounts, setDiscounts] = useState(discountCategories2);
  const [days, setDays] = useState(dummyDays);
  const [selectedDays, setSelectedDays] = useState([]);
  const [discountTimes, setDiscountTimes] = useState({
    startTime: null,
    endTime: null,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedDiscountCategory, setSelectedDiscountCategory] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [description, setDescription] = useState("");

  const handleDiscountCatSelect = (v, at, item) => {
    let array = [...discounts];
    array[at].checked = v;
    setSelectedCategory(item?.value);
    setDiscounts(array);
    if (v) {
    } else return;
  };

  const handleDaysSelect = (v, at) => {
    let array = [...days];
    array[at].checked = !array[at]?.checked;
    let selectedDays = array?.filter((val) => val?.checked);
    setSelectedDays(selectedDays);
    setDays(array);
  };

  const onPressDoneBtn = () => {
    const selectedCategories = [...discounts]
      .filter((d) => d?.checked)
      .map((d) => d?.value);

    if (selectedCategories.length === 0) {
      toast.error("Please select at least one discount category.");
      return;
    }

    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.");
      return;
    }

    if (moment(endDate).isBefore(moment(startDate))) {
      toast.error("End date cannot be before start date.");
      return;
    }

    const checkedDays = [...days].filter((d) => d?.checked);
    if (checkedDays.length === 0) {
      toast.error("Please select at least one day for the discount.");
      return;
    }

    const invalidTime = checkedDays.some(
      (d) => !d.startTime || !d.endTime || d.endTime <= d.startTime
    );
    if (invalidTime) {
      toast.error(
        "Please select valid start and end times for each selected day."
      );
      return;
    }

    const obj = {
      category: selectedCategories,
      times: checkedDays,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      description: description.trim(),
    };

    console.log(
      "✅ Discount Object:",
      obj,
      "going to be saved in",
      value,
      "and with index",
      indexToEdit
    );

    // ✅ Update specific index if provided
    if (typeof indexToEdit === "number" && value?.[indexToEdit]) {
      const updated = [...value];
      updated[indexToEdit] = obj;
      setValue(updated);
      //move to next index
      setIndexToEdit((prev) => prev + 1);
    } else {
      let array = [...value, obj];
      console.log("Going to set value for discount ", array);
      setValue(array);
      setIndexToEdit((prev) => prev + 1);
    }

    setModalOpen(false);
    toast.success("Discount details saved successfully!");
  };

  const handlechangeTime = (v, index, key) => {
    let array = [...selectedDays];
    array[index][key] = v;
    setSelectedDays(array);
    console.log("Updated selected days: ", array);
  };

  const isDiscountIncludedBefore = (d, currentVal) => {
    let found = currentVal?.category?.includes(d?.value);
    return found ? true : false;
  };

  const dayIncludedThisDiscount = (day) => {
    let currentVal = value[indexToEdit];
    let isDaypresent = currentVal?.times?.find((t) => {
      if (typeof t?.day === "string")
        return (
          t?.day?.slice(0, 3)?.toUpperCase() === day?.slice(0, 3)?.toUpperCase()
        );
      return false;
    });
    if (isDaypresent) {
      return true;
    } else return false;
  };

  useEffect(() => {
    console.log("[Discount values]", value);

    if (Array.isArray(value)) {
      const currentVal =
        typeof indexToEdit === "number" && value?.[indexToEdit]
          ? value[indexToEdit]
          : value[0];

      if (currentVal) {
        setDiscounts(
          discountCategories2?.map((item) => ({
            ...item,
            checked: isDiscountIncludedBefore(item, currentVal),
          }))
        );

        setStartDate(currentVal?.startDate || null);
        setEndDate(currentVal?.endDate || null);
        setDays(
          dummyDays.map((dayObj) => {
            const found = dayIncludedThisDiscount(dayObj?.day);
            return found
              ? {
                  ...dayObj,
                  checked: true,
                  startTime: found.startTime,
                  endTime: found.endTime,
                }
              : { ...dayObj, checked: false };
          })
        );
        setDescription(currentVal?.description || "");
      }
    }
  }, [value, indexToEdit]);

  return (
    <div className="normal-input-2">
      <Label className="figma-input-label">{label}</Label>
      <Button
        onClick={() => setModalOpen(true)}
        className="d-flex px-3 text-black full-width align-items-center justify-content-between"
      >
        <div className="d-flex flex-wrap align-items-strech gap-2">
          {value?.length > 0
            ? value?.map((item, index) => (
                <div
                  onClick={() => setIndexToEdit(index)}
                  key={index}
                  style={{ background: "#21005d" }}
                  className=" text-white d-flex align-items-center gap-2 cursor-pointer editable-pill rounded-pill px-3 py-2"
                >
                  {item?.category?.toString()}
                  <div>
                    <MdEdit size={24} />
                  </div>
                </div>
              ))
            : "Select discounts"}
        </div>
        <div className="color-primary-blue">
          <FaCaretDown size={20} />
        </div>
      </Button>
      <Modal
        isOpen={modalOpen}
        centered
        size="lg"
        toggle={() => setModalOpen((prev) => !prev)}
      >
        <ModalBody
          className="bg-white px-4"
          style={{ borderRadius: "14.76px" }}
        >
          <h4 className="color-primary-black-7 mt-3 mb-4 f-6 text-center figma-shadowed-black-text">
            {t("discountOffered")}
          </h4>
          <h5 className="color-primary-black-7 m-0">Discount category</h5>
          <Row className="g-md-0 g-2 my-3">
            {discounts?.map((item, k) => (
              <Col md={4} key={k}>
                <LabeledCheckedInput
                  label={
                    <div
                      className="d-flex align-items-center "
                      style={{ gap: "0.3rem" }}
                    >
                      <DiscountIcon
                        size={{ height: 28, width: 20 }}
                        color={item?.color}
                      />
                      {item?.title}
                    </div>
                  }
                  iconSize={30}
                  iconColor={item?.color}
                  value={item?.checked}
                  setValue={(v) => handleDiscountCatSelect(v, k, item)}
                />
              </Col>
            ))}
          </Row>
          <Row className="gy-md-0 g-3 my-4 ">
            <Col md={6}>
              <DatePickInput
                label={t("startDate")}
                placeholder={t("selectDate")}
                parentClassName={"normal-input-2"}
                value={startDate}
                setValue={setStartDate}
              />
            </Col>
            <Col md={6}>
              <DatePickInput
                label={t("endDate")}
                placeholder={t("selectDate")}
                parentClassName={"normal-input-2"}
                value={endDate}
                setValue={setEndDate}
              />
            </Col>
          </Row>
          <h5 className="color-primary-black-7 my-4">{t("everyDay")}</h5>
          <Row className="g-3">
            {days?.map((item, k) => (
              <Col md={4} key={k}>
                <LabeledCheckedInput2
                  iconSize={30}
                  label={item?.day}
                  value={item?.checked ?? dayIncludedThisDiscount(item?.day)}
                  setValue={(v) => handleDaysSelect(v, k)}
                />
              </Col>
            ))}
          </Row>
          <Row className="gy-md-0 g-3 mt-3 mb-4 ">
            {[...selectedDays]
              ?.filter((dobj) => dobj?.checked)
              ?.map((item, index) => (
                <>
                  <h4
                    className=" mb-3 mt-4 "
                    style={{ color: "rgba(18, 118, 239, 1)" }}
                  >
                    {item?.day}
                  </h4>
                  <Col md={6}>
                    <NormalInput2
                      label={t("startTime")}
                      type={"time"}
                      value={item?.startTime}
                      setValue={(v) => handlechangeTime(v, index, "startTime")}
                      placeholder={t("selectTime")}
                    />
                  </Col>
                  <Col md={6}>
                    <NormalInput2
                      label={t("endTime")}
                      type={"time"}
                      value={item?.endTime}
                      setValue={(v) => handlechangeTime(v, index, "endTime")}
                      placeholder={t("selectTime")}
                    />
                  </Col>
                </>
              ))}
          </Row>
          <Row className="g-3 mb-4">
            <Col md={12}>
              <NormalInput2
                label={t("description")}
                type={"text"}
                value={description}
                setValue={(v) => setDescription(v)}
                placeholder={t("enterDescription")}
              />
            </Col>
          </Row>
          <Row className="justify-content-center  g-0 ">
            <Col md={6}>
              <Button
                onClick={onPressDoneBtn}
                className="standard-rounded-btn full-width"
              >
                {t("done")}
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DiscountModal;
